import { Navigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { useAuth } from "context/AuthContext";
import { useUserContext } from "context/UserContext";
import getDefaultPathByRole from "utils/getDefaultPathByRole";
import { normalizeRoleLevel } from "utils/roleUtils";

const PrivateRoute = ({ component: Component, allowedRoleLevels, ...rest }) => {
  const { user, loading } = useAuth();
  const { roleLevel } = useUserContext() || {};
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/authentication/sign-in" state={{ from: location }} replace />;
  }

  if (Array.isArray(allowedRoleLevels) && allowedRoleLevels.length > 0) {
    const numericRoleLevel = normalizeRoleLevel(roleLevel);
    if (!numericRoleLevel) {
      return <div>Loading...</div>;
    }
    if (!allowedRoleLevels.includes(numericRoleLevel)) {
      const fallbackPath = getDefaultPathByRole(numericRoleLevel);
      if (fallbackPath && fallbackPath !== location.pathname) {
        return <Navigate to={fallbackPath} replace />;
      }
      return <div>Access denied.</div>;
    }
  }

  return <Component {...rest} />;
};

PrivateRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  allowedRoleLevels: PropTypes.arrayOf(PropTypes.number),
};

PrivateRoute.defaultProps = {
  allowedRoleLevels: null,
};

export default PrivateRoute;
